export const MOCK_USER = {
  id: 1,
  username: 'yangxuming',
  password: 'yxm13315965753...',
  displayName: '杨旭鸣',
  avatarUrl: null
}

export function createSeedData() {
  return {
    projects: [],
    libraries: [],
    sections: [],
    trash: []
  }
}
